module.exports = __webpack_public_path__ + "img/u108.856345ce.svg";